import { render, staticRenderFns } from "./DetailPane.vue?vue&type=template&id=7821672c&scoped=true&"
import script from "./DetailPane.vue?vue&type=script&lang=ts&"
export * from "./DetailPane.vue?vue&type=script&lang=ts&"
import style0 from "./DetailPane.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DetailPane.vue?vue&type=style&index=1&id=7821672c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7821672c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/rensvannijnatten/source/repos/AZNConnect/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCard,VCardTitle,VContainer,VDialog,VFlex,VIcon,VLayout,VSpacer,VTab,VTabs,VToolbar,VTooltip})
